import {SubClient} from '../../../services/cellcast.v2.types'

export const GetCurrentData = (): SubClient => {
  const persists = localStorage.getItem('persist:root')

  const testa = JSON.parse(persists || '{}')
  const userData = JSON.parse(testa?.userDetails || '{}')

  const currentUser = userData?.userDetails
  let user = currentUser?.data?.user

  if (!user?.region) {
    return {
      ...user,
      region: 'au',
    }
  }

  return user
}

export const GetCurrentDataIsDefaultRegion = (): boolean => {
  const userData = GetCurrentData()

  if (userData?.region === 'au') {
    return true
  }
  return false
}
